<template>
  <section class="def-lang">
    <a
      v-for="item in languages"
      :href="item.link"
      :class="{ 'def-lang__item_active': item.current }"
      class="def-lang__item"
    >
      {{ item.name }}
    </a>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DefLang',
  computed: {
    ...mapState({
      languages: ({ results }) => results?.siteLanguages?.items,
    }),
  },
};
</script>

<style lang="scss" scoped>
.def-lang {
  display: flex;
  align-items: center;
  &__item {
    font-weight: 600;
    font-size: rem(14);
    line-height: 125%;
    color: var(--color-dark-grey);
    text-transform: uppercase;
    border: 1px solid #cacece;
    padding: 4px 12px;

    //@include point-lg {
    //  border: unset;
    //  font-size: rem(12);
    //  line-height: 100%;
    //  padding: unset;
    //  transition: 0.2s linear color;
    //  &:hover {
    //    color: var(--color-link-hover);
    //  }
    //}
    &_active {
      border-color: var(--color-main);
      background-color: var(--color-main);
      color: #fff;
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
}
</style>
